import type { ValueOf } from '../util/typeUtils';

export const CHAT_RESOLVERS = {
    /** intern resolver — saga-only (system context); not granted to human roles */
    getChatLinkState: 'getChatLinkState',
    getChats: 'getChats',
    getInboxUnreadSummary: 'getInboxUnreadSummary',
    getMessages: 'getMessages',
} as const;

export type CHAT_RESOLVER = ValueOf<typeof CHAT_RESOLVERS>;
